import { useEffect, useState } from "react";
import { TenbaggerLogo } from "#/components/ui/logo.tsx";

type ChartLoaderProps = {
	isReady: boolean;
};

export function ChartLoader({ isReady }: ChartLoaderProps) {
	const [showLoader, setShowLoader] = useState(true);
	const [isExiting, setIsExiting] = useState(false);

	useEffect(() => {
		if (!isReady) {
			setShowLoader(true);
			setIsExiting(false);
			return;
		}

		setIsExiting(true);

		const timeoutId = window.setTimeout(() => {
			setShowLoader(false);
			setIsExiting(false);
		}, 350);

		return () => window.clearTimeout(timeoutId);
	}, [isReady]);

	if (!showLoader) return null;

	return (
		<div
			className={`absolute inset-0 flex items-center justify-center bg-trade-surface text-label2 uppercase text-trade-text-secondary transition-opacity duration-300 ease-out ${
				isExiting ? "pointer-events-none opacity-0" : "opacity-100"
			}`}
		>
			<div
				className={`transition-transform duration-300 ease-out ${
					isExiting
						? "translate-y-2 scale-95 motion-safe:animate-none"
						: "motion-safe:animate-bounce [animation-duration:1.2s]"
				}`}
			>
				<TenbaggerLogo width={60} height={60} />
			</div>
		</div>
	);
}
